import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App, Input, Modal } from 'antd'
import { refreshMoneyQueries } from '@/features/bill/index.ts'
import { useTRPC } from '@/trpc/react.ts'

export function CancelRental({ id, onClose }: { id: number; onClose: () => void }) {
  const [open, setOpen] = useState(true)
  const trpc = useTRPC(),
    cache = useQueryClient(),
    { message } = App.useApp(),
    save = useMutation(trpc.order.rental.cancel.mutationOptions()),
    [reason, setReason] = useState('')
  return (
    <Modal
      open={open}
      title="取消未生效租赁"
      onCancel={() => setOpen(false)}
      afterClose={onClose}
      confirmLoading={save.isPending}
      closable={!save.isPending}
      keyboard={!save.isPending}
      mask={{ closable: false }}
      cancelButtonProps={{ disabled: save.isPending }}
      okButtonProps={{ danger: true, disabled: !reason.trim() }}
      onOk={async () => {
        try {
          await save.mutateAsync({ rentalOrderId: id, reason })
          await refreshMoneyQueries(cache, trpc)
          setOpen(false)
        } catch (e) {
          void message.error(e instanceof Error ? e.message : '取消失败')
        }
      }}
    >
      <p>取消前须处理正式费用及退款；草稿作废，资源预留释放。</p>
      <Input.TextArea
        disabled={save.isPending}
        aria-label="取消原因"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        maxLength={1000}
      />
    </Modal>
  )
}
